import type { ReactNode, Ref } from 'react';
import classNames from 'classnames';
import * as styles from './CarouselContent.module.scss';

type CarouselContentProps = {
  children: ReactNode;
  className?: string;
  variant?: 'product' | 'review';
  ref?: Ref<HTMLDivElement>;
};

const containerListId = 'carousel-container-scroll';

const CarouselContent = ({ className, children, variant, ref }: CarouselContentProps) => {
  const wrapperStyles = classNames(
    styles.container,
    {
      [styles.productCarousel]: variant === 'product',
      [styles.reviewCarousel]: variant === 'review',
    },
    className,
  );

  return (
    <div className={wrapperStyles} ref={ref} data-testid={containerListId}>
      {children}
    </div>
  );
};

export { CarouselContent };
